import * as React from 'react';
import { useSelector } from 'react-redux';
import { produktgruppenSelector } from 'store/lookups/selector';
import { requestProduktgruppen } from 'store/lookups/actions';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { DefaultButton, Dialog, DialogFooter, DialogType, Fabric, PrimaryButton } from '@fluentui/react';
import { viewStyles } from 'styles/viewStyles';
import { formStyles } from 'styles/formStyles';
import { FormTextField } from 'formComponents/FormTextField';
import { SavingState } from 'api/savingState';
import { addProduktgruppe, defaultProduktgruppe, Produktgruppe, updateProduktgruppe } from 'api/produktgruppe';

const styles = mergeStyleSets({
    container: {
        position: 'relative',
        height: 'calc(100vh - 120px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    searchBar: {
        display: 'grid',
        gridTemplateColumns: '1fr max-content',
        gridColumnGap: 10,
        marginTop: 10,
    },
});

export const Produktgruppen: React.FC = () => {
    const produktgruppen = useSelector(produktgruppenSelector);

    const [editData, setEditData] = React.useState<Produktgruppe | null>(null);

    const save = async () => {
        if (!editData) {
            return;
        }
        if (editData?.nr === -1) {
            await addProduktgruppe(editData);
        } else {
            await updateProduktgruppe(editData);
        }
        await requestProduktgruppen();
        setEditData(null);
    };

    return (
        <Fabric className={styles.container}>
            <div className={styles.searchBar}>
                <div />

                <PrimaryButton
                    onClick={() => setEditData({ ...defaultProduktgruppe, nr: -1 })}
                    text="Neue Produktgruppe"
                />
            </div>
            <div className={viewStyles.listContainerScroll}>
                <table className={formStyles.lookupTable}>
                    <thead className={formStyles.lookupTableHead}>
                        <tr>
                            <td className={formStyles.lookupTableCell}>Text</td>
                            <td className={formStyles.lookupTableCell} />
                        </tr>
                    </thead>
                    <tbody className={formStyles.lookupTableBody}>
                        {produktgruppen
                            .sort((a, b) => a.text.localeCompare(b.text))
                            .map((produktgruppe) => (
                                <tr key={produktgruppe.nr} className={formStyles.looupTableRow}>
                                    <td className={formStyles.lookupTableCell}>{produktgruppe.text}</td>
                                    <td className={formStyles.lookupTableActionCell}>
                                        <DefaultButton
                                            className={formStyles.lookupTableEditButton}
                                            onClick={() => setEditData({ ...produktgruppe })}
                                            text="Bearbeiten"
                                        />
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {editData && (
                <Dialog
                    hidden={false}
                    minWidth={800}
                    dialogContentProps={{
                        title: 'Produktgruppe bearbeiten',
                        type: DialogType.normal,
                    }}
                >
                    <FormTextField
                        value={editData.text}
                        savingState={SavingState.notChanged}
                        options={{}}
                        onChange={(newValue): void => {
                            if (editData) {
                                setEditData({
                                    ...editData,
                                    text: newValue as string,
                                });
                            }
                        }}
                        label="Name"
                    />
                    <DialogFooter>
                        <DefaultButton onClick={() => setEditData(null)} text="Abbruch" />
                        <PrimaryButton onClick={save} text="Speichern" />
                    </DialogFooter>
                </Dialog>
            )}
        </Fabric>
    );
};
